import { timeScalesEnum } from '../enums/timeScales.enum';
import { DateTimeChartDataItemModel } from './date-time-chart-data-item.model';

export class DateTimeChartDataModel {
    scale: timeScalesEnum;
    items: DateTimeChartDataItemModel[];

    constructor(scale: timeScalesEnum, items: DateTimeChartDataItemModel[]) {
        this.scale = scale;
        this.items = items;
    }
}
